/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/overlays/games-overlay',['require','core/overlay-screen','core/engine','underscore','jquery'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var OverlayScreen = require('core/overlay-screen');
  var Engine = require('core/engine');
  var _ = require('underscore');
  var $ = require('jquery');

  /*****************************************************************************************************************///}

  var GamesOverlay = OverlayScreen.extend({

  /////////////
  // METHODS /{
  /////////////

    events: {
      'click .game-item': 'gameClickHandler'
    },

    initialize: function(options)
    {
      this.options = _.assign(this.options, this.model.get('options'));
      this.options.model.set('minigames', Engine.module('Paging').root.find('minigames').content.models);
      OverlayScreen.prototype.initialize.apply(this, arguments);
      //console.log('games init', this.model);
    },

    onRender: function()
    {
      //this.setupGames();
    },

    onShow: function()
    {
      this.finish();
    },

    setupGames: function()
    {
      var _games = this.$el.find('.game-item');
      _games.on('click', _.bind(this.gameClickHandler, this));
      // function(_value, _key) {
      //   //console.log(_value, this);
      // });
    },

    gameClickHandler: function(e)
    {
      var _gameBtn = $(e.currentTarget);
      var _locked = _gameBtn.attr('data-locked');
      if (_locked === 'true')
      {
        //console.log('locked', _locked);
        return false;
      }

      var _id = _gameBtn.attr('data-id');

      Engine.module('Navigation').go(_id);

      return false;
    }

  /*****************************************************************************************************************///}

  });

  return GamesOverlay;

});

